module.exports = __webpack_public_path__ + "static/delete_user-d2d1f7b866541fdf8015ee52cc6db624.png";